import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

const historyConstants = {
    HISTORY_LOADED: 'HISTORY_LOADED',
    HISTORY_DETAILS_LOADED: 'HISTORY_DETAILS_LOADED'
};

export const historyFulfilledConstants = getActionTypesResult(historyConstants, '_FULFILLED');
export const historyRejectedConstants = getActionTypesResult(historyConstants, '_REJECTED');

export const fetchHistory = createAsyncAction(historyConstants.HISTORY_LOADED, deviceId =>
    api.get(`history/${deviceId}`).then(res => res.data)
);

export const fetchHistoryDetails = createAsyncAction(historyConstants.HISTORY_DETAILS_LOADED, historyId =>
    api.get(`history/details/${historyId}`).then(res => res.data)
);
